import { useMemo } from 'react';
import { DirectSalesDealManagementFilters } from './Filters.types';

export const useHasActiveFilters = (filters: DirectSalesDealManagementFilters): boolean =>
  useMemo(() => {
    const {
      campaignName,
      campaignReference,
      campaignMediaType,
      startDate,
      endDate,
      advertiser,
      brand,
      productCategory,
      specialist,
      agency,
      updatedBy,
      createdBy,
      createdAt,
      dropDate,
      salesTeam,
      salesPerson,
      adminPerson,
      campaignStatus,
    } = filters;

    return Boolean(
      campaignName ||
        campaignReference ||
        campaignMediaType ||
        startDate ||
        endDate ||
        advertiser ||
        brand ||
        productCategory ||
        specialist ||
        agency ||
        updatedBy ||
        createdBy ||
        createdAt ||
        dropDate ||
        salesTeam ||
        salesPerson ||
        adminPerson ||
        campaignStatus === undefined ||
        (campaignStatus?.length ?? 0) > 0,
    );
  }, [filters]);
